<template>
  <b-row class="black-text white-background word-spacing">
    <b-col col sm="auto" class="pt-4 pl-0 ml-0" v-html="leftText">
    </b-col>
    <b-col col sm="auto" class="pt-4 ml-auto">
      {{ centerText }}
    </b-col>
    <b-col col sm="auto" class="pt-4 ml-auto pr-0 mr-0">
      {{ rightText }}
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "ImageDescriptionRow",
  props: {
    leftText: String,
    centerText: String,
    rightText: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
